import styled, { css, keyframes } from 'styled-components';

import { pxToRem, StatusColor } from 'utils/scss';

const removeHighlight = keyframes`
  from {
    object-fit: contain;
      border-radius: ${pxToRem('6px')};
      box-shadow: 0 ${pxToRem('4px')} ${pxToRem(
  '16px'
)} 0 rgba(7, 11, 21, 0.12);
      background-color: #fff;
      cursor: auto;
  }

  to {
    object-fit: contain;
      border-radius: unset;
      box-shadow: unset;
      background-color: transparent;
      cursor: auto;
  }
`;

export const TableContainer = styled.div`
  ${props =>
    props.variant === 'fileHistoryRowTable' &&
    css`
      border-radius: ${pxToRem('8px')};
      border: solid ${pxToRem('1px')} rgba(7, 11, 21, 0.16);
      background-color: rgba(255, 255, 255, 0.03);
      margin: ${pxToRem('10px')} ${pxToRem('40px')};
      padding-right: ${pxToRem('40px')};
    `}
`;

export const StatusHeader = styled.div`
  display: grid;
  grid-gap: ${pxToRem('16px')};
  grid-template-columns: ${props =>
    props.columnWidths ? props.columnWidths : '2fr repeat(6, 1fr)'};
  justify-items: left;
  align-items: center;
  padding: 0 1rem;
`;

export const HeaderTitle = styled.div`
  text-transform: uppercase;
  justify-self: ${props => props.position};
  margin-right: ${props => props.marginRight};
  padding: ${pxToRem('10px')} ${pxToRem('0px')};

  :hover {
    ${props =>
      props.sortable &&
      css`
        border-radius: ${pxToRem('8px')};
        background-color: ${props.theme.colors.blue.five};
        box-shadow: 0 0 0 ${pxToRem('10px')} ${props.theme.colors.blue.five};
        cursor: pointer;
      `}
  }
`;

export const Row = styled.div`
  display: grid;
  grid-gap: ${pxToRem('16px')};
  grid-template-columns: ${props =>
    props.columnWidths ? props.columnWidths : '2fr repeat(6, 1fr)'};
  height: ${pxToRem('64px')};
  margin-bottom: ${pxToRem('5px')};
  justify-items: left;
  align-items: center;
  transition: hover 500ms ease;
  padding: 0 1rem;
  position: relative;

  ${props =>
    props.selectedHovered &&
    css`
      object-fit: contain;
      border-radius: ${pxToRem('6px')};
      box-shadow: 0 ${pxToRem('4px')} ${pxToRem('16px')} 0 rgba(7, 11, 21, 0.12);
      background-color: #fff;
      cursor: auto;
      animation: ${removeHighlight} 8s forwards;
    `}

  ${props =>
    props.hasAccordion &&
    css`
      object-fit: contain;
      border-radius: ${pxToRem('6px')};
      box-shadow: 0 ${pxToRem('40px')} ${pxToRem('32px')} -${pxToRem('16px')} ${props.theme.colors.black.five};
      border: solid ${pxToRem('2px')} ${props.theme.colors.whiteShade.one};
      background-image: ${props.theme.colors.gradient.hover};
      cursor: pointer;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: solid ${pxToRem('1px')} ${props.theme.colors.lightGray2};
    `}
    :hover {
    ${props =>
      props.selection &&
      !props.checked &&
      css`
        object-fit: contain;
        border-radius: ${pxToRem('6px')};
        box-shadow: 0 0 0 ${pxToRem('2px')}
            ${props.theme.colors.backgroundOpacity},
          0 ${pxToRem('40px')} ${pxToRem('32px')} -${pxToRem('16px')} ${props.theme.colors.black.five};
        background-image: ${props.theme.colors.gradient.hover};
      `}
    ${props =>
      props.detailhover &&
      css`
        object-fit: contain;
        border-radius: ${pxToRem('6px')};
        box-shadow: 0 ${pxToRem('4px')} ${pxToRem('16px')} 0
          rgba(7, 11, 21, 0.12);
        background-color: #fff;
        cursor: auto;
      `}
  }

  background-color: ${props => props.theme.colors.greenGradient};

  ${props =>
    props.checked &&
    css`
      object-fit: contain;
      border-radius: ${pxToRem('6px')};
      box-shadow: 0 ${pxToRem('4px')} ${pxToRem('16px')} 0 rgba(7, 11, 21, 0.12);
      background-color: #fff;
    `}
`;
export const AccordionWrapper = styled.div`
  margin-bottom: ${pxToRem('5px')};
  justify-items: left;
  align-items: center;
  transition: hover 500ms ease;
  object-fit: contain;
  border-bottom-left-radius: ${pxToRem('6px')};
  border-bottom-right-radius: ${pxToRem('6px')};
  box-shadow: 0 ${pxToRem('40px')} ${pxToRem('32px')} -${pxToRem('16px')} ${props => props.theme.colors.black.five};
  border: solid ${pxToRem('2px')} ${props => props.theme.colors.whiteShade.one};
  background-image: ${props => props.theme.colors.gradient.hover};
  cursor: pointer;
  margin-top: -${pxToRem('5px')};
  border-bottom: none;

  > div {
    border-bottom: solid ${pxToRem('1px')}
      ${props => props.theme.colors.lightGray2};
  }

  :hover {
    ${props =>
      props.selection &&
      !props.checked &&
      css`
        object-fit: contain;
        border-radius: ${pxToRem('6px')};
        box-shadow: 0 ${pxToRem('40px')} ${pxToRem('32px')} -${pxToRem('16px')} ${props.theme.colors.black.five};
        border: solid ${pxToRem('2px')} ${props.theme.colors.whiteShade.one};
        background-image: ${props.theme.colors.gradient.hover};
        cursor: pointer;
      `}
    ${props =>
      props.detailhover &&
      css`
        object-fit: contain;
        border-radius: ${pxToRem('6px')};
        box-shadow: 0 ${pxToRem('4px')} ${pxToRem('16px')} 0
          rgba(7, 11, 21, 0.12);
        background-color: #fff;
        cursor: auto;
      `}
  }

  background-color: ${props => props.theme.colors.greenGradient};

  ${props =>
    props.checked &&
    css`
      object-fit: contain;
      border-radius: ${pxToRem('6px')};
      box-shadow: 0 ${pxToRem('4px')} ${pxToRem('16px')} 0 rgba(7, 11, 21, 0.12);
      background-color: #fff;
    `}
`;

export const AccordionRow = styled.div`
  display: grid;
  grid-gap: ${pxToRem('16px')};
  grid-template-columns: ${props =>
    props.columnWidths ? props.columnWidths : '1fr repeat(6, 1fr)'};
  height: ${pxToRem('64px')};

  > div {
    display: flex;
    align-items: center;
  }

  > div:first-child {
    grid-column: 2/3;
  }
`;

export const CellWrapper = styled.div`
  justify-self: ${props => props.position};
  word-break: break-all;
  position: relative;
  ${props =>
    props.onClick &&
    css`
      cursor: pointer;
    `}
  ${props =>
    props.linkCharger &&
    css`
      :hover {
        text-decoration: underline;
      }
    `}

    ${props =>
      props.linkLead &&
      css`
        &,
        & > :first-child {
          color: ${props => props.theme.colors.blue.one};
        }
        :hover {
          text-decoration: underline;
        }
      `}
`;

export const CellWrapperStatusMenu = styled.div`
  justify-self: ${props => props.position};
  word-break: break-all;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
`;

export const DownArrowStatusMenuContainer = styled.div`
  cursor: pointer;
  position: absolute;
  right: ${pxToRem('-20px')};
`;

export const DownArrowStatusMenu = styled.div`
  width: ${pxToRem('8px')};
  height: ${pxToRem('8px')};
  border: solid
    ${props =>
      props.type === 'fileHistory'
        ? props.fileStatus === 'WARNING'
          ? props.theme.colors.semantic.primary
          : props.theme.colors.semantic.secondary
        : props.theme.colors.mainBlue};
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};

  transform: ${props => (props.toRotate ? 'rotate(225deg)' : 'rotate(45deg)')};
  -webkit-transform: ${props =>
    props.toRotate ? 'rotate(225deg)' : 'rotate(45deg)'};
  margin-left: ${pxToRem('8px')};
  transition-duration: 0.5s;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  -moz-transition-property: transform;
`;

export const StatusMenuContainer = styled.div`
  position: relative;
`;

export const LeadStatusMenu = styled.div`
  position: absolute;
  width: ${pxToRem('225px')};
  border-radius: ${pxToRem('8px')};
  box-shadow: 0 ${pxToRem('6px')} ${pxToRem('20px')} 0 rgba(7, 11, 21, 0.12);
  background: white;
  z-index: 10;
  top: 20px;
  left: -100px;
  padding: ${pxToRem('15px')} ${pxToRem('5px')};

  & > span {
    width: 100%;
    padding: ${pxToRem('5px')} ${pxToRem('25px')};
    &:hover {
      background-color: ${props => props.theme.colors.blue.five};
      font-weight: 600;
    }
  }
`;

export const AccordionCellWrapper = styled.div`
  word-break: break-all;
`;
export const AdditionalText = styled.span`
  margin-left: 8px;
  height: ${pxToRem('24px')};
  width: ${pxToRem('24px')};
  border-radius: 100%;
  background-color: ${props => props.theme.colors.quiteBlue};
  color: ${props => props.theme.colors.blue.one};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${pxToRem('12px')};
  font-weight: bold;
  cursor: pointer;
`;

export const ItemWrapper = styled.div`
  ${props =>
    (props && props.type === 'chargePointSerialNumber') ||
    (props.type === 'chargePointId' &&
      css`
        :hover {
          cursor: pointer;
          text-decoration: underline;
        }
      `)}

  ${props =>
    Array.isArray(props.value) &&
    css`
      display: flex;
      align-items: center;
    `}
        

  ${props =>
    (props.type === 'status' || props.type === 'statusLead') && props.value
      ? css`
          ${StatusColor(props.value)}
          border-radius: ${pxToRem('20px')};
          padding: ${pxToRem('6px')} ${pxToRem('24px')};
          height: ${pxToRem('28px')};
          font-size: ${pxToRem('12px')};
          font-weight: bold;
          text-transform: uppercase;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.33;
          letter-spacing: ${pxToRem('2px')};
          text-align: center;
          text-align: ${props.position};
          display: flex;
          align-items: center;
          justify-content: center;
        `
      : css`
          font-size: ${pxToRem('16px')};
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          color: ${props.rowIdStatus === 'SKIPPED'
            ? props.theme.colors.semantic.primary
            : props.rowIdStatus === 'INVALID'
            ? props.theme.colors.semantic.secondary
            : props.theme.colors.black.one};
          text-align: ${props.position};

          ${props.highLightRoleOnHover &&
            css`
              background-color: ${props.theme.colors.blue.five};
              box-shadow: 0 0 0 ${pxToRem('12px')}
                ${props.theme.colors.blue.five};
              border-radius: ${pxToRem('6px')};
            `}
        `}
`;

export const StatusIconwrapper = styled.div`
  margin-right: ${pxToRem('7px')};
`;

export const IconWrapper = styled.div`
  width: ${pxToRem('18px')};
  height: ${pxToRem('18px')};
  border-radius: 50%;
  border: ${pxToRem('2px')} solid ${props => props.theme.colors.blue.one};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: ${pxToRem('2px')} ${pxToRem('2px')} ${pxToRem('4px')} 0
    rgba(0, 0, 0, 0.08);
  background-image: linear-gradient(135deg, #7cb2fd, #467afb);
`;

export const DeleteIcon = styled.div`
  color: ${props => props.theme.colors.mainBlue};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VoidIcon = styled.div`
  width: ${pxToRem('18px')};
  height: ${pxToRem('18px')};
  border-radius: 50%;
  opacity: 0.16;
  border: ${pxToRem('1.5px')} solid ${props => props.theme.colors.black.one};
  cursor: pointer;
  background-color: ${props => props.theme.colors.white};

  ${props =>
    props.hovered &&
    css`
      border: ${pxToRem('2px')} solid ${props.theme.colors.blue.one};
      opacity: 1;
    `}
`;
export const Void = styled.div`
  width: ${pxToRem('18px')};
  height: ${pxToRem('18px')};
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DownloadIcon = styled.div`
  padding: ${pxToRem('1px')};
  color: ${props => props.theme.colors.mainBlue};
  cursor: pointer;
  font-size: ${props => pxToRem(`${props.size}px`)};
`;
export const AccordionIcon = styled.div`
  padding: ${pxToRem('1px')};
  color: ${props => props.theme.colors.mainBlue};
  transform: rotate(180deg);
  opacity: 0;
  transition: all 250ms ease-out 0s;
  justify-self: center;

  ${props =>
    props.rotation &&
    css`
      transform: rotate(0deg);
      opacity: 1;
    `}
  ${props =>
    props.hovered &&
    css`
      opacity: 1;
    `}
`;

export const ActionIconWrapper = styled.div`
  align-items: baseline;
  justify-self: ${props => props.position};
`;

export const DownArrow = styled.div`
  width: ${pxToRem('8px')};
  height: ${pxToRem('8px')};
  border: solid
    ${props =>
      props.type === 'fileHistory'
        ? props.fileStatus === 'WARNING'
          ? props.theme.colors.semantic.primary
          : props.theme.colors.semantic.secondary
        : props.theme.colors.mainBlue};
  border-width: 0 ${pxToRem('3px')} ${pxToRem('3px')} 0;
  display: inline-block;
  padding: ${pxToRem('3px')};

  transform: ${props =>
    props.upsideDown ? 'rotate(45deg)' : 'rotate(225deg)'};
  -webkit-transform: ${props =>
    props.upsideDown ? 'rotate(45deg)' : 'rotate(225deg)'};
  margin-left: ${pxToRem('8px')};
  transition-duration: 0.5s;
  transition-property: transform;
  -webkit-transition-duration: 0.5s;
  -moz-transition-property: transform;
`;

export const IconContainer = styled.div`
  justify-self: ${props => props.position};
  display: ${props => (props.show ? 'unset' : 'none')}
    ${props =>
      props.accessor === 'action' &&
      css`
        cursor: pointer;
        position: relative;
      `};
`;

export const RowIconWrapper = styled.span`
  width: ${pxToRem('20px')};
`;

export const SpinnerIcon = styled.div`
  background: url(${props => props.icon});
  background-repeat: no-repeat;
  width: ${({ customSize }) =>
    customSize ? `${pxToRem(`${customSize}px`)};` : `${pxToRem('32px')};`}
  height: ${({ customSize }) =>
    customSize ? `${pxToRem(`${customSize}px`)};` : `${pxToRem('32px')};`}
  background-size: contain;

  ${props =>
    props.marginRight &&
    css`
      margin-right: ${pxToRem(`${props.marginRight}px`)};
    `};
`;
